// cSpell:ignore Silae complexExpression mathOperator
import type { SilaeSourceFormData } from "@/types/silae";

import type { FormatterContext } from "./types";
import { formatSource } from "./sources";

const MAX_VISIBLE = 3;

export function formatComplexExpression(
  expression: SilaeSourceFormData[] | undefined,
  ctx: FormatterContext,
): string {
  if (!expression || expression.length === 0) {
    return ctx.t("step5Validation.complexExpression.notDefined");
  }

  const formatItem = (item: SilaeSourceFormData) =>
    formatSource(item, ctx, { formatComplex: formatComplexExpression });

  if (expression.length === 1) {
    return formatItem(expression[0]);
  }

  const join = (items: SilaeSourceFormData[]): string =>
    items
      .map((item, idx) => {
        const display = `(${formatItem(item)})`;
        if (idx === 0) return display;
        const previous = items[idx - 1];
        const op = previous.mathOperator || "+";
        return ` ${op} ${display}`;
      })
      .join("");

  if (expression.length <= MAX_VISIBLE) {
    return join(expression);
  }

  const head = join(expression.slice(0, 2));
  const remaining = expression.length - 2;
  const moreLabel = ctx.t("step5Validation.formatters.connectives.andMore", {
    count: remaining,
    defaultValue:
      remaining > 1
        ? "+ {{count}} autres éléments"
        : "+ {{count}} autre élément",
  });
  return `${head} ${moreLabel}`;
}
